// extracted by mini-css-extract-plugin
export default {"analytics-container":"Analytics_analytics-container__R7H7g","right-item":"Analytics_right-item__bmyd2","line-tab":"Analytics_line-tab__OxSbG","tab-item":"Analytics_tab-item__8IdRS"};